import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSessionService } from '../auth-session.service';

/**
 * AuthGuard — protects routes that require an active session (e.g. /layout).
 * Uses cached session state so no extra network call is made on route changes.
 * The session is initialized once at app startup via AppComponent's ngOnInit.
 */
export const AuthGuard: CanActivateFn = async () => {
    const authSessionService = inject(AuthSessionService);
    const router = inject(Router);

    const isValid = await authSessionService.ensureSessionState();

    if (isValid) {
        const roleId = Number(sessionStorage.getItem('roleId'));
        if (roleId === 4) {
            return router.createUrlTree(['/login']);
        }
        return true;
    }

    return router.createUrlTree(['/login']);
};
